import React, { useState } from 'react';
import { FadeInUp } from './Animations';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) { setSubmitted(true); setEmail(''); }
  };

  return (
    <section id="contact" style={{
      background: 'linear-gradient(135deg, #1A5C38 0%, #1E8449 60%, #27AE60 100%)',
      padding: 'clamp(60px, 8vw, 90px) clamp(20px, 4vw, 52px)',
      textAlign: 'center', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: '-60px', right: '-60px',
        width: '300px', height: '300px', borderRadius: '50%',
        background: 'rgba(201,151,58,0.12)',
      }} />
      <div style={{
        position: 'absolute', bottom: '-80px', left: '-40px',
        width: '240px', height: '240px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.05)',
      }} />
      <FadeInUp>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: '560px', margin: '0 auto' }}>
          <span style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '11px', fontWeight: 600, letterSpacing: '4px',
            textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)',
            marginBottom: '12px', display: 'block',
          }}>Stay Connected</span>
          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 700,
            color: '#fff', marginBottom: '14px', lineHeight: 1.2,
          }}>
            Join My <em style={{ fontStyle: 'italic', color: '#C9973A' }}>Inner Circle</em>
          </h2>
          <p style={{
            fontSize: '15px', color: 'rgba(255,255,255,0.75)',
            lineHeight: 1.75, marginBottom: '36px',
          }}>
            Get weekly tips on wellness, business, and building the life you deserve — delivered straight to your inbox. No spam, ever.
          </p>
          {submitted ? (
            <div style={{
              background: 'rgba(255,255,255,0.12)',
              borderRadius: '16px', padding: '24px',
              border: '1px solid rgba(255,255,255,0.2)',
            }}>
              <p style={{
                color: '#C9973A', fontFamily: "'Playfair Display', serif",
                fontSize: '20px', fontStyle: 'italic',
              }}>
                Thank you for joining! Welcome to the inner circle ✦
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{
              display: 'flex', flexDirection: 'column',
              maxWidth: '480px', margin: '0 auto', gap: '12px',
            }}>
              <input
                type="email" required
                placeholder="Enter your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={{
                  width: '100%', padding: '16px 20px',
                  border: 'none', outline: 'none',
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px', color: '#1A1A1A',
                  background: '#fff', borderRadius: '12px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                }}
              />
              <button type="submit" style={{
                width: '100%', padding: '16px 28px',
                background: 'linear-gradient(135deg, #C9973A, #E8B84B)',
                border: 'none', color: '#fff',
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px', fontWeight: 700,
                letterSpacing: '2px', textTransform: 'uppercase',
                cursor: 'pointer', borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(201,151,58,0.35)',
                transition: 'transform 0.25s, box-shadow 0.25s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(201,151,58,0.45)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(201,151,58,0.35)';
              }}
              >
                Join Now — It is Free
              </button>
            </form>
          )}
        </div>
      </FadeInUp>
    </section>
  );
}
